import React from 'react';
import { withAppContext } from '../context/VeloAppContext';
import { VeloNotificationContainer } from 'velo-react-components';

export const Notifications = withAppContext(({ notification, snackbar }) => ({
  notification,
  snackbar,
}))((props) => <VeloNotificationContainer {...props} />);
